import { EsitoSpedizioneDiffida } from '../../../models/esito-spedizione-diffida';

export class EsitoSpedizioneAdapter {

    static clonEsitoSpedizione(esitoSpedizione: EsitoSpedizioneDiffida): EsitoSpedizioneDiffida {
      let esitoSpedizioneClone: EsitoSpedizioneDiffida = new EsitoSpedizioneDiffida();
      if (esitoSpedizione.id) {
        esitoSpedizioneClone.id = esitoSpedizione.id;
      }
      esitoSpedizioneClone.dataSpedizione = esitoSpedizione.dataSpedizione;
      esitoSpedizioneClone.tipoEsitoSpedizione = esitoSpedizione.tipoEsitoSpedizione ? JSON.parse(JSON.stringify(esitoSpedizione.tipoEsitoSpedizione)) : null;
      esitoSpedizioneClone.motivoEsitoSpedizione = esitoSpedizione.motivoEsitoSpedizione ? JSON.parse(JSON.stringify(esitoSpedizione.motivoEsitoSpedizione)) : null;
      esitoSpedizioneClone.note = esitoSpedizione.note;
      return esitoSpedizioneClone;
    }
}
